import type { HsClippingPlane } from '../../engine-new/objects/clipping/clipping-plane.class';
import type { HsMoveTool } from './move-tool.class';
import type { HsToolAction } from './tool-action.class';

export class HsClippingArrow {
  public arrowsX: [HsMoveTool, HsMoveTool] | null = null;
  public arrowsY: [HsMoveTool, HsMoveTool] | null = null;
  public arrowsZ: [HsMoveTool, HsMoveTool] | null = null;

  constructor(
    public readonly arrow: HsMoveTool,
    public readonly plane: HsClippingPlane,
    public readonly action: HsToolAction
  ) {}
}
